import type { BackEndADH } from '@cdab/scania/qpr/interactor'
import { getClient } from './client'

export function useBackend(): BackEndADH {
  const client = getClient()

  return client
}
